import { createContext, Dispatch, useContext } from 'react';
import { ExternalShareOption, IPostUIState, PostOption, PostUIStateAction } from './types';

interface IPostContext {
  state: IPostUIState;
  dispatch: Dispatch<PostUIStateAction>;
}

export const initialPostUIState: IPostUIState = {
  option: PostOption.Link,
  shareOption: ExternalShareOption.LinkShare,
  moderatorMode: true,
  engagePost: false,
  brandedPost: false,
  validUrl: false,
  pin: false,
  schedule: false,
  commentary: false,
  disclosures: false,
  tracking: false,
  share: false,
};

export const PostUIContext = createContext<IPostContext>({
  state: initialPostUIState,
  dispatch: () => null,
});

export function postContextReducer(prevState: IPostUIState, action: PostUIStateAction) {
  switch (action.type) {
    case 'option':
      return { ...prevState, option: action.value };
    case 'shareOption':
      return { ...prevState, shareOption: action.value };
    case 'validUrl':
      return { ...prevState, validUrl: action.value };
    case 'engagePost':
      return { ...prevState, engagePost: action.value };
    case 'brandedPost':
      return { ...prevState, brandedPost: action.value };
    case 'share':
      return { ...prevState, share: action.value };
    default:
      return { ...prevState, [action.type]: !prevState[action.type] };
  }
}

export const usePostContext = () => useContext(PostUIContext);
